import React from "react";

import Section from "./Section";

const Contact = () => {
  return (
    <Section
      bgColor="bg-gold"
      textColor="text-gold"
      comment="Contact"
      isBottom={true}
    >
      <h2 className="font-otomanopee text-white  mb-16" id="contact">
        おといあわせ
      </h2>
      <form
        className="contact_form grid"
        name="contact"
        method="post"
        data-netlify="true"
        action="/success"
      >
        <input type="hidden" name="form-name" value="contact" />

        <label className="label" htmlFor="name">
          お名前
        </label>
        <input
          type="text"
          name="name"
          id="name"
          className="contact__field input"
          placeholder="Your Name"
          minlength={1}
        ></input>
        <label className="label" htmlFor="email">
          メールアドレス
        </label>
        <input
          name="email"
          type="email"
          id="email"
          className="contact__field input"
          placeholder="example@domain.com"
        ></input>

        <label className="label" htmlFor="subject">
          件名
        </label>
        <input
          name="subject"
          id="subject"
          type="text"
          className="contact__field input"
          placeholder="Subject"
        ></input>
        <label className="label" htmlFor="message">
          お問い合わせ内容
        </label>
        <textarea
          name="message"
          id="message"
          className="contact__field textarea"
          placeholder="Your Message"
        ></textarea>
        <div data-netlify-recaptcha="true"></div>
        <button
          className="relative top-0 bg-navy text-white tracking-widest w-24 mt-2 p-1 place-self-end rounded drop-shadow-md transition-all duration-75 hover:top-px hover:drop-shadow-none"
          type="submit"
        >
          送信
        </button>
      </form>
    </Section>
  );
};

export default Contact;
